// キャラの SVG をページに置く（2026-10-21 に app.js から分けた。描く処理は 2026-10-23 に中身の core/render.ts へ）
import { S } from './state.js';
import { SIZE } from './config.js';
import { txt } from './text.js';
import { $, el } from './util.js';
import { attachLayers } from './core/render.js';
import { buildNameLayer } from './name.js';

// ---- キャラ（SVG） ----
export function buildStage() {
  S.stageSvg = el('svg', { viewBox: '0 0 ' + SIZE + ' ' + SIZE, role: 'img', 'aria-label': txt('chara') });
  // レイヤーは g#chaSvgMake の中に並べる（本物と同じ形。CHOCO 広場の avatar.js は #chaSvgMake からキャラを作る）
  const make = el<SVGGElement>('g', { id: 'chaSvgMake' });
  S.stageSvg.appendChild(make);
  attachLayers(S.stageSvg, make);
  // 表示の拡大は、キャラの SVG を包む .view に掛ける（SVG 自体は弾む動きに使う）
  const view = document.createElement('div');
  view.className = 'view';
  view.id = 'view';
  view.appendChild(S.stageSvg);
  $('stage').appendChild(view);
  buildNameLayer();
}
